import {
  CustomEventProperties,
  EventDataKey
} from "core/analytics/analytics.types";
import { getContextNameFromUrlBasePath } from "core/analytics/analytics.utils";
import { APP_NAME } from "core/common-types/app.constants";
import { useCurrentUserQuery } from "core/gateways/user/UserHooks";

import { useAccount } from "@azure/msal-react";

export const useAccountClaimAnalyticsParams = (): Partial<
  Record<EventDataKey | "userId", string | number | boolean | undefined>
> => {
  const account = useAccount();
  const claims = account?.idTokenClaims;

  return {
    userId: claims?.oid as string,
    tenantId: claims?.bpt as string
  };
};

const useCurrentUserAnalyticsParams = (): CustomEventProperties => {
  const { data: user } = useCurrentUserQuery();
  return { userRole: user?.roles.map(x => x.roleCode).join(",") };
};

export const useDefaultAnalyticsParams = () => {
  const claimParams = useAccountClaimAnalyticsParams();
  const userParams = useCurrentUserAnalyticsParams();
  const appContext = getContextNameFromUrlBasePath();

  return { ...claimParams, ...userParams, appId: APP_NAME, appContext };
};
